import Devices from "../models/devices.ts";

const DeviceLayoutDryerDummyData = [
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8f1",
        type: "dryer",
        name: "Dryer 1",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "dryer",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8f2",
        type: "dryer",
        name: "Dryer 2",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "dryer",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8f3",
        type: "dryer",
        name: "Dryer 3",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "dryer",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8f4",
        type: "dryer",
        name: "Dryer 4",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "dryer",
        cycle: 1000,
    }),
    new Devices({
        id: "84960297-c1fa-16b3-a339-60ab148ff8f5",
        type: "dryer",
        name: "Dryer 5",
        status: "error",
        courseName: undefined,
        remainTime: undefined,
        model: "FH069FD_T",
        dryType: "dryer",
        cycle: 1000,
    }),
];

export default DeviceLayoutDryerDummyData;
